import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { KeycloakService } from 'keycloak-angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { BrukerService } from 'src/app/services/bruker/bruker.service';
import { KeycloakUserInfo } from 'src/app/services/bruker/bruker.types';

@Component({
  selector: 'app-slettebruker',
  templateUrl: './slettebruker.component.html',
  styleUrls: ['./slettebruker.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class SlettebrukerComponent implements OnInit {
  @Input() userInfo: KeycloakUserInfo; // attribute "sub" is keycloak user ID
  deleteInProgress = false;
  error?: string;

  constructor(
    public modalCtrl: ModalController,
    public keycloak: KeycloakService,
    public brukerService: BrukerService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    undefined;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  deleteKCUser() {
    this.deleteInProgress = true;
    const deleteRes = this.brukerService.deleteKeycloakUser(this.userInfo.sub);
    deleteRes.subscribe({
      next: () => {
        this.analyticsService.logEvent_selectContent('profil slettet bruker');
        this.keycloak.logout();
      },
      error: (err) => {
        this.deleteInProgress = false;
        this.analyticsService.logEvent_selectContent(
          'profil feilet slettet bruker'
        );
        this.error =
          'Det skjedde en feil, og brukeren ble ikke slettet. Prøv igjen, eller kontakt oss om problemet vedvarer.';
      }
    });
  }
}
